var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpenseReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22710",
    "data-name": "Group 22710",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.422,
    height: 21.051,
    viewBox: "0 0 16.422 21.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-expense-report-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2055",
    "data-name": "Rectangle 2055",
    width: 16.422,
    height: 21.051,
    fill: "#c5c9f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22709",
    "data-name": "Group 22709",
    clipPath: "url(#clip-path-expense-report-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11862",
    "data-name": "Path 11862",
    d: "M16.422,2.708A2.721,2.721,0,0,0,13.714,0h-6.9A2.379,2.379,0,0,0,4.979.786L.874,4.63A2.693,2.693,0,0,0,0,6.639v11.7a2.721,2.721,0,0,0,2.708,2.708H13.714a2.721,2.721,0,0,0,2.708-2.708ZM1.747,6.551a1.078,1.078,0,0,1,.349-.7L6.115,2.009a1.054,1.054,0,0,1,.7-.262H6.9V5.066a1.659,1.659,0,0,1-1.66,1.66Zm11.792,7.163L10.22,17.47a.944.944,0,0,1-.611.262H9.521a1.078,1.078,0,0,1-.7-.349l-1.834-2.8-2.8,2.97A.865.865,0,0,1,2.97,16.335l3.581-3.756a.992.992,0,0,1,.7-.262,1.078,1.078,0,0,1,.7.349l1.834,2.8,2.533-2.883a.935.935,0,0,1,1.223-.087A.843.843,0,0,1,13.539,13.714Zm-.262-5.328H9.521a.825.825,0,0,1-.874-.874.825.825,0,0,1,.874-.874h3.756a.875.875,0,0,1,.874.874.825.825,0,0,1-.874.874m0-3.494H9.521a.825.825,0,0,1-.874-.874.825.825,0,0,1,.874-.874h3.756a.875.875,0,0,1,.874.874.825.825,0,0,1-.874.874",
    fill: "#c5c9f6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseReportsIcon);
export default __webpack_public_path__ + "static/media/expense-reports-icon.6b9bb1f72b7e841efed6ad795428c2e9.svg";
export { ForwardRef as ReactComponent };